module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"schedule_demo":"Schedule Demo","date":"Date","time":"Time","venue":"Venue (Optional)","success_message":{"appointment_scheduled":"Appointment scheduled successfully","appointment_rescheduled":"Appointment rescheduled successfully"},"error_message":{"unable_to_schedule":"Unable to schedule appointment. Please try again."}}}')
  delete Component.options._Ctor
}
